/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_WALLET_BALANCE = gql`
query GetMyBalance($did: String!) {
  getMyBalance(did: $did) {
    address
    provider_type
    did
    balance_in_crypto {
      matic {
        amount
      }
      wei {
        amount
      }
      gwei {
        amount
      }
      ether {
        amount
      }
      etherOrMatic {
        amount
      }
      cryptoSymbol
      cryptoType
    }
    balance_in_fiat {
      USD
      INR
    }
    xchange_rates {
      USD
      INR
    }
    avlBalToWithdraw
    avlResellCredit
  }
}
`